import { numberFormatterInternational } from 'app/utils/telephonyHelpers';

export function getSimulaneousRingHelpText(
  validPhoneNumber: boolean,
  isInTrial: boolean,
  phoneNumber: string,
): JSX.Element {
  let helpTextPhoneNumber: JSX.Element | false = false;

  if (!isInTrial && validPhoneNumber) {
    phoneNumber = `(${numberFormatterInternational({
      phoneNumber,
    })})`;
  } else if (isInTrial) {
    helpTextPhoneNumber = (
      <strong>
        You can not activate simultaneous ring when you are in trial.
      </strong>
    );
  } else {
    helpTextPhoneNumber = (
      <strong>
        To activate simultaneous ring you need to add a phone number to your
        profile(see / settings / profile)
      </strong>
    );
  }

  return (
    <>
      <p>
        With simultaneous ring you will receive calls in Dixa and on your phone{' '}
        {phoneNumber} at the same time.
      </p>
      <p> {helpTextPhoneNumber} </p>
    </>
  );
}

export function getSimulaneousRingHelpTitle(
  validPhoneNumber: boolean,
  isInTrial: boolean,
): string {
  if (!isInTrial && validPhoneNumber) {
    return 'Simultaneous ring';
  }
  if (isInTrial) {
    return 'Simultaneous ring (on trial)';
  }
  return 'Simultaneous ring (phone number needed)';
}
